import getMapData from './_getMapData.js';

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

export default mapCacheGet;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_mapCacheGet.js
// module id = 1264
// module chunks = 14